import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1b9a07ef&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "../../../../src/css/setting/global.css?vue&type=style&index=0&id=1b9a07ef&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b9a07ef",
  null
  
)

export default component.exports